import { put, call } from "redux-saga/effects";
import * as apis from "../../network/apis/countries";
import { getCountriesResponse } from "./actions";

export function* getCountriesSaga({ payload }) {
  try {
    const response = yield call(apis.getCountries, payload);
    yield put(
      getCountriesResponse({
        list: response.data.countries,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"]
        }
      })
    );
  } catch (err) {
    console.error(err);
  }
}
